import {
  Component,
  h,
  ComponentInterface,
  Prop,
  Element,
  State,
} from '@stencil/core';

/**
 * Spinners are used to show the progress of an indeterminate operation.
 * @slot - Used for loading messages
 */
@Component({
  tag: 'nano-spinner',
  styleUrl: 'spinner.scss',
  shadow: true,
})
export class Spinner implements ComponentInterface {
  @Element() el: HTMLNanoSpinnerElement;
  @State() hasText: boolean = false;

  /** The type of spinner animation. dna should be used for larger, page loads. Circle for smaller component loaders. */
  @Prop() type: 'dna' | 'circle' = 'dna';

  /** Displays absolutely with an overlay */
  @Prop({ reflect: true }) overlay: boolean = false;

  componentWillLoad() {
    this.hasText = !!this.el.childNodes.length;
  }

  render() {
    return (
      <div class="spinner" aria-busy="true" aria-live="polite">
        <div class="spinner__loader">
          {this.type === 'dna' && (
            <div class="spinner__dna">
              <div class="spinner__dnatrack spinner__dnatrack--1">
                <div class="spinner__dnadot spinner__dnadot--1"></div>
                <div class="spinner__dnadot spinner__dnadot--2"></div>
              </div>
              <div class="spinner__dnatrack spinner__dnatrack--2">
                <div class="spinner__dnadot spinner__dnadot--3"></div>
                <div class="spinner__dnadot spinner__dnadot--4"></div>
              </div>
              <div class="spinner__dnatrack spinner__dnatrack--3">
                <div class="spinner__dnadot spinner__dnadot--5"></div>
                <div class="spinner__dnadot spinner__dnadot--6"></div>
              </div>
              <div class="spinner__dnatrack spinner__dnatrack--4">
                <div class="spinner__dnadot spinner__dnadot--7"></div>
                <div class="spinner__dnadot spinner__dnadot--8"></div>
              </div>
              <div class="spinner__dnatrack spinner__dnatrack--5">
                <div class="spinner__dnadot spinner__dnadot--9"></div>
                <div class="spinner__dnadot spinner__dnadot--10"></div>
              </div>
            </div>
          )}
          {this.type === 'circle' && <span class="spinner__spin"></span>}
        </div>
        {this.hasText && (
          <div class="spinner__text">
            <slot />
          </div>
        )}
        {this.overlay && <div class="spinner__overlay"></div>}
      </div>
    );
  }
}
